import { Star } from 'lucide-react';

export function StarRating({ rating, maxRating = 5, size = 'md', interactive = false, onChange }) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };

  return (
    <div className="flex gap-1" data-testid="star-rating">
      {[...Array(maxRating)].map((_, index) => (
        <button
          key={index}
          type="button"
          disabled={!interactive}
          onClick={() => interactive && onChange?.(index + 1)}
          className={interactive ? 'cursor-pointer hover:scale-110 transition-transform' : 'cursor-default'}
          data-testid={`star-${index + 1}`}
        >
          <Star
            className={`${sizeClasses[size]} ${
              index < rating ? 'fill-warning text-warning' : 'fill-none text-border'
            }`}
          />
        </button>
      ))}
    </div>
  );
}
